import { PaginatedTable } from '@app/components/paginated-table';
import { TableProps } from '@app/components/table';
import { IDepartment } from '../types';
import { DepartmentRow } from './department-row';
interface Props {
  tableProps: TableProps;
  rows?: IDepartment[];
  loading: boolean;
  canAddDepartment: string;
}

const DepartmentList = ({ tableProps, rows, loading, canAddDepartment }: Props) => {
  const TABLE_HEAD = [
    { id: 'id', label: 'Id', align: 'center' },
    { id: 'name', label: 'Name', align: 'center' },
    { id: 'desc', label: 'Description', align: 'center' },
    ...(canAddDepartment
      ? [{ id: 'Action', label: 'Action', align: 'center', sortable: false }]
      : []),
  ];
  return (
    <PaginatedTable<IDepartment>
      head={TABLE_HEAD}
      tableProps={tableProps}
      data={rows}
      loading={loading}
      isServerSidePaging={false}
    >
      {(row) => (
        <DepartmentRow
          row={row}
          canAddDepartment={canAddDepartment}
          selected={tableProps.selected.includes(row.id)}
          onSelectRow={() => {
            ('');
          }}
        />
      )}
    </PaginatedTable>
  );
};

export { DepartmentList };
